<template>
    <div>
        <div>
            <div class="">
                <div class="tabView">
                    <div class="buttonBar">
                    <div class="buttonBar_AudioControl"> <i class="material-icons">volume_up</i></div>
                    <div class="buttonBar_LiveStream"><i class="material-icons">play_arrow</i></div>
                    <div class="buttonBar_MatchLive buttonBar_SelectedButton buttonBar_MatchLive-13 buttonBar_MatchLive-13-hard "></div>
                        </div>
                    <div class="closableTabView_Button "><i class="material-icons">arrow_drop_down</i></div>
                    <div class="closableTabViewContainer ">
                        <!----><div class="matchLiveView ">
                                   <div class="iframeimg">
                                       <img src="../assets/img/live-stream.jpg" />
                                   </div>

                                </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
 
</template>

<script>
    export default {
        name: 'Widget'
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .tabView {
        position: relative;
    }

    .iframeimg {
        width: 100%;
        height: 50%;
    }
    .buttonBar {
        background-color: #474747;
        padding: 0 31px 0 32px;
        text-align: center;
        font-size: 0;
        height: 29px;
    }
    .buttonBar_AudioControl {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 32px;
        height: 29px;
        line-height: 29px;
        text-align: center;
        font-size: 10px;
        background-color: #474747;
        border-left: 1px solid #545454;
        border-right: 1px solid #545454;
        cursor: pointer;
    }
    .buttonBar_AudioControl:before {
        font-family: bet365UI;
        speak: none;
        font-style: normal;
        font-weight: 400;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    .buttonBar_LiveStream, .buttonBar_MatchLive {
        display: inline-block;
        font-size: 13px;
        line-height: 29px;
        height: 29px;
        cursor: pointer;
    }
    .buttonBar_LiveStream.buttonBar_SelectedButton, .buttonBar_LiveStream:hover, .buttonBar_MatchLive.buttonBar_SelectedButton, .buttonBar_MatchLive:hover {
        color: #ffdf1b;
    }
    .buttonBar_MatchLive {
        display: inline-block;
        font-size: 13px;
        line-height: 29px;
        height: 29px;
        cursor: pointer;
    }
    .buttonBar_ResizeView {
        display: block;
        position: absolute;
        top: 1px;
        right: 31px;
        width: 31px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        font-size: 15px;
        background-color: #474747;
        border-left: 1px solid #545454;
        color: #999;
        cursor: pointer;
    }
    .buttonBar_ResizeView:before {
        font-family: bet365UI-icomoon !important;
        speak: none;
        font-style: normal;
        font-weight: 400;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    .closableTabView_Button {
        display: block;
        position: absolute;
        top: 1px;
        right: 0;
        width: 31px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        font-size: 5px;
        background-color: #474747;

        border-left: 1px solid #545454;
        cursor: pointer;
    }
    .closableTabView_Button:before {
        font-family: bet365UI;
        speak: none;
        font-style: normal;
        font-weight: 400;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    .closableTabViewContainer {
        width: 100%;
        margin-bottom: 1px;
    }
    .matchLiveView {
        background-color: #393939;
        border-top: 1px solid #303030;
    }
    .matchLiveView_Container {
        margin: 0 auto;
        max-width: 450px;
    }
    .ml13-MatchLiveTennisModule {
        transition-property: padding-left,padding-right,max-width;
        background-color: #393939;
        padding-left: 24px;
        padding-right: 24px;
        margin: auto;
        max-width: 450px;
    }

    .ml13-AllStats {
        transition-property: padding-bottom;
        display: table;
        table-layout: fixed;
        width: 100%;
        padding-bottom: 41px;
    }
    .ml13-AllStats_Wrapper {
        display: table-cell;
        vertical-align: top;
        padding-top: 11px;
    }
    .ml13-Stat {
        text-align: center;
    }
    .ml13-Stat_Text {
        transition-property: font-size,line-height;
        display: inline-block;
        vertical-align: top;
        font-size: 14px;
        line-height: 18px;
        color: #ddd;
        min-width: 24px;
        padding: 0 2px 5px;
        border-bottom: 2px solid #fff;
        margin-bottom: 5px;
    }
    .ml13-Stat_Header {
        transition-property: font-size,line-height;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        display: block;
        font-size: 11px;
        line-height: 13px;
        color: #999;
        text-align: center;
    }
    .ml13-AllStats_Middle {
        transition-property: width;
        width: 252px;
    }
    .ml13-AllStats_Middle, .ml13-AllStats_Wrapper {
        display: table-cell;
        vertical-align: top;
        padding-top: 11px;
    }
    .ml13-SplitStatsBar {
        font-size: 0;
    }
    .ml13-SplitStatsBar + .ml13-SplitStatsBar {
        margin-top: 14px;
    }
    .ml13-SplitStatsBar {
        font-size: 0;
    }
    .ml13-AllStats_Middle, .ml13-AllStats_Wrapper {
        display: table-cell;
        vertical-align: top;
        padding-top: 11px;
    }
    .ml13-SplitStatsBar ~ .ml13-SplitStatsBar .ml13-SplitStatsBar_BarOne, .ml13-SplitStatsBar ~ .ml13-SplitStatsBar .ml13-SplitStatsBar_BarTwo {
        margin-bottom: 11px;
    }
    .ml13-SplitStatsBar_BarOne {
        text-align: right;
        padding-right: 5px;
    }
    .ml13-SplitStatsBar_BarOne, .ml13-SplitStatsBar_BarTwo {
        transition-property: margin-bottom;
        display: inline-block;
        width: 50%;
        margin-bottom: 4px;
    }
    .ml13-SplitStatsBar ~ .ml13-SplitStatsBar .ml13-SplitStatsBar_BarOne, .ml13-SplitStatsBar ~ .ml13-SplitStatsBar .ml13-SplitStatsBar_BarTwo {
        margin-bottom: 11px;
    }
    .ml13-SplitStatsBar_BarTwo {
        padding-left: 5px;
    }
    .ml13-SplitStatsBar_BarOne, .ml13-SplitStatsBar_BarTwo {
        transition-property: margin-bottom;
        display: inline-block;
        width: 50%;
        margin-bottom: 4px;
    }
    .material-icons {
        background-color: #474747;
        color: #999;
        cursor: pointer;
    }
</style>
